import APIClient from '@/shared/http/clients/api'

const APIBusiness = process.env.APIBaseURLBusinessCommon
const resourceName = 'ContratoConta'

const GetByAccount = (companyId, accountId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/empresa/${companyId}/conta/${accountId}`, data, config)
const GetByContract = (companyId, contractId, data = {}, config = {}) => APIClient.get(`${APIBusiness}/${resourceName}/empresa/${companyId}/contrato/${contractId}`, data, config)
const SaveAccess = (companyId, accountId, data = [], config = {}) => APIClient.post(`${APIBusiness}/${resourceName}/empresa/${companyId}/conta/${accountId}`, data, config)
const SaveContractAccess = (companyId, contractId, data = [], config = {}) => APIClient.post(`${APIBusiness}/${resourceName}/empresa/${companyId}/contrato/${contractId}`, data, config)
const SaveAccessInclusiveCopy = (data = [], config = {}) => APIClient.post(`${APIBusiness}/${resourceName}/inclusivos`, data, config)
const SaveAccessExclusiveCopy = (data = [], config = {}) => APIClient.post(`${APIBusiness}/${resourceName}/exclusivos`, data, config)

const AccountContractsRepository = {
  GetByAccount,
  GetByContract,
  SaveAccess,
  SaveContractAccess,
  SaveAccessInclusiveCopy,
  SaveAccessExclusiveCopy
}

export default AccountContractsRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/accountcontracts.js